import React from "react";

const ListIcon = ({ iconClass, color }) => {
  return (
    <svg
      width={20}
      height={21}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={iconClass}
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        d="M10.3081 7.8999H14.6831"
        stroke={color}
        strokeOpacity="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.31689 7.8999L5.94189 8.5249L7.81689 6.6499"
        stroke={color}
        strokeOpacity="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3081 13.7334H14.6831"
        stroke={color}
        strokeOpacity="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.31689 13.7334L5.94189 14.3584L7.81689 12.4834"
        stroke={color}
        strokeOpacity="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.49984 18.8332H12.4998C16.6665 18.8332 18.3332 17.1665 18.3332 12.9998V7.99984C18.3332 3.83317 16.6665 2.1665 12.4998 2.1665H7.49984C3.33317 2.1665 1.6665 3.83317 1.6665 7.99984V12.9998C1.6665 17.1665 3.33317 18.8332 7.49984 18.8332Z"
        stroke={color}
        strokeOpacity="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ListIcon;
